// Közös téma kezelés localStorage-ral
const THEME_STORAGE_KEY = 'hodito-theme';
// Backwards-compatible migration: 'light' -> 'hodito-light', 'dark' -> 'hodito-dark'
function migrateTheme(stored) {
    if (stored === 'hodito-light' || stored === 'hodito-dark')
        return stored;
    if (stored === 'dark')
        return 'hodito-dark';
    return 'hodito-light';
}
export function getStoredTheme() {
    if (typeof window === 'undefined')
        return 'hodito-light';
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return migrateTheme(stored);
}
export function setStoredTheme(theme) {
    if (typeof window === 'undefined')
        return;
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    applyTheme(theme);
    // Custom event küldése ugyanabban az ablakban (React komponenseknek)
    window.dispatchEvent(new CustomEvent('themechange', { detail: theme }));
}
export function applyTheme(theme) {
    if (typeof document === 'undefined')
        return;
    const html = document.documentElement;
    if (theme === 'hodito-dark') {
        html.classList.add('dark');
    }
    else {
        html.classList.remove('dark');
    }
}
// Oldal betöltésekor alkalmazza a tárolt témát
export function initTheme() {
    const theme = getStoredTheme();
    applyTheme(theme);
    return theme;
}
